import { combineReducers } from "redux";
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

//users
import {userReducer} from "./userReducer";
import {adminCompanyReducer} from "./adminReducer";
import {bobzaReducer} from "./bobzaReducer";


//slices
import productDetailsReducer from './slice/product';

//normal
import {searchReducer} from "./searchReducer";
import {cartReducer} from "./cartReducer";
import {drawerReducer} from "./drawerReducer";
import { couponReducer } from "./couponReducer";
import { productDBReducer } from "./ProductDBReducer";
//import { productDetailsReducer } from "./productReducer";

// Reducers from admin side of the project
import authReducer from '../components/Admin/src/reducers/authReducer';
import vendorReducer from '../components/Admin/src/reducers/vendorReducer';
import categoryReducer from '../components/Admin/src/reducers/categoryReducer';
import productReducer from '../components/Admin/src/reducers/productReducer';
import adminReducer from '../components/Admin/src/reducers/adminListReducer';
import dashboardReducers from '../components/Admin/src/reducers/dashboardReducer'
import orderReducer from '../components/Admin/src/reducers/orderReducer';
//import rootAdminReducer from "../components/Admin/src/reducers/rootReducer"




const rootPersistConfig = {
    key: 'root',
    storage,
    keyPrefix: 'redux-',
    whitelist: []
  };
  
  const productPersistConfig = {
    key: 'productDetails',
    storage,
    keyPrefix: 'redux-',
    whitelist: ['sortBy', 'checkout']
  };

 const rootReducer = combineReducers({  
    user: userReducer,
    adminCompany: adminCompanyReducer,
    bobza: bobzaReducer,
    auth: authReducer,
    vendor: vendorReducer,
    category: categoryReducer,
    product: productReducer,
    admin: adminReducer,
    dashboard : dashboardReducers,
    order : orderReducer,
    search:searchReducer,
    cart:cartReducer,
    drawer:drawerReducer,
    coupon: couponReducer,
    productDB:productDBReducer,
    productDetils:persistReducer(productPersistConfig, productDetailsReducer),
});

export { rootPersistConfig, rootReducer };